import { Button, Checkbox } from "@material-ui/core";
import { TreeItem, TreeView } from "@material-ui/lab";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import Loader from "../common/loader/Loader";

function Horses() {
  const [data, setData] = useState();

  useEffect(() => {
    Axios.get(
      "https://www.goalserve.com/getfeed/5da0cb2417174c52778908da0d957fe9/racing/usa?json=1"
    )
      .then((response) => response.data)
      .then((data) => {
        setData(data);
      });
  }, []);

  const [selectedItems, setSelectedItems] = useState([]);
  const handleToggle = (id, childrenIds = []) => {
    let newSelectedItems;
    if (selectedItems.includes(id)) {
      // Remove parent and its children
      newSelectedItems = selectedItems.filter(
        (item) => item !== id && !childrenIds.includes(item)
      );
    } else {
      // Add parent and its children
      newSelectedItems = [
        ...selectedItems,
        id,
        ...childrenIds.filter((childId) => !selectedItems.includes(childId)),
      ];
    }
    setSelectedItems(newSelectedItems);
  };

  const handleParentToggle = (id, childrenIds) => {
    handleToggle(id, childrenIds);
  };

  const handleImport = () => {
    const value = {
      ...data,
      scores: {
        ...data.scores,
        tournament: data.scores.tournament
          .filter((tournament) => selectedItems.includes(tournament.id))
          .map((tournament) => ({
            ...tournament,
            race: tournament.race.filter((race) =>
              selectedItems.includes(race.id)
            ),
          })),
      },
    };

    console.log(value);
  };

  console.log(selectedItems);

  if (!data) return <Loader />;
  if (!data.scores) return <div>No data</div>;
  return (
    <div className="flex flex-col w-full h-full gap-4 ag-theme-material">
      <div className="flex justify-between">
        <h2>Import Horses - goalserve</h2>
        <Button
          type="button"
          onClick={handleImport}
          color="primary"
          variant="contained"
        >
          Import Selected
        </Button>
      </div>
      <TreeView
        defaultCollapseIcon={
          <div className="flex gap-2">
            <i className="w-4 fa-solid fa-chevron-down"></i>
            <i className="fa-solid fa-trophy"></i>
          </div>
        }
        defaultExpandIcon={
          <div className="flex gap-1">
            <i className="w-4 fa-solid fa-chevron-right"></i>
            <i className="fa-solid fa-trophy"></i>
          </div>
        }
        defaultEndIcon={<i className="fa-solid fa-horse-head"></i>}
        multiSelect
      >
        {data.scores.tournament.map((tournament) => (
          <TreeItem
            key={tournament.id}
            nodeId={tournament.id}
            onClick={() =>
              handleParentToggle(
                tournament.id,
                tournament.race.map((race) => race.id)
              )
            }
            label={
              <div>
                <Checkbox
                  checked={selectedItems.includes(tournament.id)}
                  onChange={() =>
                    handleParentToggle(
                      tournament.id,
                      tournament.race.map((race) => race.id)
                    )
                  }
                />
                {tournament.name}
              </div>
            }
          >
            {tournament.race.map((race) => (
              <TreeItem
                key={race.id}
                nodeId={race.id}
                onClick={() => handleToggle(race.id)}
                label={
                  <div>
                    <Checkbox
                      checked={selectedItems.includes(race.id)}
                      onChange={() => handleToggle(race.id)}
                    />
                    {race.name}
                  </div>
                }
              />
            ))}
          </TreeItem>
        ))}
      </TreeView>
    </div>
  );
}

export default Horses;
